import { getDefaultHeaders } from "./utils";

export async function fetchCharacterInfo(comicInputFileId) {
  try {
    const headers = await getDefaultHeaders();
    const requestOptions = {
      method: "GET",
      headers: headers,
    };

    const url = `/api/character-info/${comicInputFileId}/`;
    
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || `HTTP error ${response.status}`);
    }
    
    return await response.json();
  } catch (err) {
    console.error("Error fetching character information:", err);
    throw err;
  }
}
